import { React, useState } from "react";
import CategoriesPage from "../components/CategoriesPage";
import Layout from "../Layout/MainLayout";

function Categories() {
  return (
    <Layout>
      <CategoriesPage />
    </Layout>
  );
}

export default Categories;
